var React = require('react');

function OneoffBulletedList (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 35c-3 3-4 5-4 8 0 7 6 12 13 12 2 0 4-1 7-4s4-5 4-8-1-5-4-8-4-4-8-4-5 1-8 4zM53 38v6l1 4h77V37H92l-39 1zM15 95c-3 3-4 5-4 8 0 4 1 5 4 8s5 4 8 4 5-1 8-4 4-5 4-8-1-5-4-8-4-4-8-4-5 1-8 4zM53 98v6l1 5h77V98l-39-1-39 1z"}));
}

OneoffBulletedList.displayName = "OneoffBulletedList";

OneoffBulletedList.defaultProps = {"version":"1","width":"192","height":"192","viewBox":"0 0 144 144"};

module.exports = OneoffBulletedList;

OneoffBulletedList.default = OneoffBulletedList;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/oneoff-bulleted-list.svg
// module id = 777
// module chunks = 0